import React from 'react';
import { SettingsHeader, SettingsPanel, AppRouter, ScreenshotFrame, ComponentLoader } from './partials';
import {
	Footer,
	SavedViewsCarousel,
	Navbar,
	ExplorePanel,
	SiteWideNotice,
	CookieConsentNotice,
	MessageBox,
	SubjectPickerMenu,
	LocationPickerMenu,
	ViewPickerMenu,
	Breadcrumb,
	CorrelationNoticeOnce,
	DataUnavailableNotice,
} from '../../reusablePartials';
import { getUrlQueryParams } from '../../actions';
import { useAppPipeline } from '../../hooks';
import styles from './styles.css';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../context/AppState.jsx';
import useKeyboardShortcuts from '../../hooks/useKeyboardShortcuts.js';

const isOnOverview = (urlParams) =>
	urlParams?.view === 'overview' &&
	(urlParams?.subview === 'absoluteTrends' || urlParams?.subview === 'annualAvgTrend');

export default function Layout() {
	const urlParams = getUrlQueryParams();
	const [state, dispatch] = useAppContext();
	useAppPipeline({ urlParams });
	useKeyboardShortcuts(state, dispatch);
	const { t, i18n } = useTranslation();
	if (urlParams.takingss) {
		return (
			<>
				<ScreenshotFrame />
			</>
		);
	} else {
		return (
			<>
				<header>
					<Navbar />
					<Breadcrumb />
				</header>
				<ExplorePanel />
				<div className={isOnOverview(urlParams) ? styles.backgroundOffWhite : styles.backgroundWhite}>
					<SettingsHeader />
					<SettingsPanel />

					<div className="uk-container">
						<DataUnavailableNotice />
						<AppRouter />
						<ComponentLoader />
					</div>
				</div>
				{/*<SavedViewsCarousel />*/}
				{/*<Footer />*/}
				<SiteWideNotice />
				<CookieConsentNotice />
				<MessageBox />
				<CorrelationNoticeOnce />
				<ScreenshotFrame />
			</>
		);
	}
}
